import { render, staticRenderFns } from "./MOH.vue?vue&type=template&id=4cceeb27&scoped=true"
import script from "./MOH.vue?vue&type=script&lang=js"
export * from "./MOH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cceeb27",
  null
  
)

export default component.exports